import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import { useRef, useCallback } from 'react';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { isEqual } from 'lodash';

import { useMediaQuery, MediaQuery } from '../../../hooks/useMediaQuery';
import { brandColors } from '../../../constants/colors';
import { autoplayProps } from '../../../config/carousel';
import { FeatureCardType } from '../../../types/content';
import FeatureCard from '../feature-card/feature-card';
import * as S from './styles';

/* eslint-disable-next-line */
type FeatureCardsProps = {
  featureCardsContent: FeatureCardType[];
  swiperColor: string;
};

export function FeatureCards(props: FeatureCardsProps) {
  const { featureCardsContent, swiperColor } = props;
  const sliderRef = useRef() as any;
  const isTablet = useMediaQuery(MediaQuery.MD);

  const slidesPerGroup = isTablet
    ? 1
    : featureCardsContent.length < 3
    ? featureCardsContent.length
    : 3;

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const navigationColor = isEqual(swiperColor, brandColors.SUBZERO_HEX)
    ? 'text-primaryBlue'
    : 'text-primaryRed';

  const navigation = (
    <div className="hidden lg:block">
      <BsChevronLeft
        className={`absolute left-10 xl:left-24 top-2/4 -translate-y-2/4 text-header4 z-20 cursor-pointer ${navigationColor}`}
        onClick={handlePrev}
      />
      <BsChevronRight
        className={`absolute right-10 xl:right-24 top-2/4 -translate-y-2/4 text-header4 z-20 cursor-pointer ${navigationColor}`}
        onClick={handleNext}
      />
    </div>
  );

  const slides = featureCardsContent.map((featureCard) => {
    return (
      <SwiperSlide className="flex justify-center" key={featureCard.heading}>
        <FeatureCard
          featureCardContent={featureCard}
          hoverColor={swiperColor}
        />
      </SwiperSlide>
    );
  });

  return (
    <S.SwiperContainer paginationColor={swiperColor}>
      {navigation}
      <Swiper
        autoplay={autoplayProps}
        loop={true}
        modules={[Autoplay, Pagination]}
        onInit={(core: SwiperCore) => {
          sliderRef.current = core.el;
        }}
        pagination={{ clickable: true }}
        slidesPerView={slidesPerGroup}
        slidesPerGroup={slidesPerGroup}
        spaceBetween={20}
        speed={900}
        style={{ position: 'unset' }}
      >
        {slides}
      </Swiper>
    </S.SwiperContainer>
  );
}

export default FeatureCards;
